/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Name_InputInputs */

const vi_shop_group_name_input = /** @type {(inputs: Shop_Group_Name_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên nhóm`)
};

/**

* @param {Shop_Group_Name_InputInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_name_input = /** @type {((inputs?: Shop_Group_Name_InputInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Name_InputInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_name_input(inputs)
});